<template>
  <div class="flex justify-between gap-4 mb-2 mx-4 text-sm text-quaternary">
    <div class="w-full">Item</div>
    <div class="flex gap-4">
      <div class="w-20">Rate</div>
      <div class="w-20">Qty</div>
      <div class="w-40">Discount</div>
      <div class="w-16 mr-20">Total</div>
    </div>
  </div>
  <div class="flex flex-col">
    <InvoiceItem
      v-for="item in modelValue"
      :key="item.id"
      :item="item"
      :read-only="readOnly"
      @item-updated="itemUpdated"
      @item-validated="itemValidated"
      @item-removed="itemRemoved"
    />
    <InvoiceItemNew
      :invoice-template-id="invoiceTemplateId"
      :dealership-id="dealershipId"
      :catalog-items="catalogItems"
      @item-added="newItemAdded"
    />
  </div>
</template>

<script setup>
import InvoiceItem from './InvoiceItem.vue'
import InvoiceItemNew from './InvoiceItemNew.vue'

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
    default: () => []
  },
  invoiceTemplateId: {
    type: Number,
    required: true
  },
  dealershipId: {
    type: Number,
    required: false,
    default: null
  },
  readOnly: {
    type: Boolean,
    default: false
  },
  catalogItems: {
    type: Array,
    required: true,
    default: () => []
  }
})
const emit = defineEmits(['itemRemoved', 'update:modelValue', 'itemValidated', 'itemAdded'])
function itemUpdated(item) {
  // update the modelValue with the updated item
  const itemFound = props.modelValue.find(i => i.id === item.id)
  const index = props.modelValue.indexOf(itemFound)
  const newItems = [...props.modelValue]
  newItems[index] = item
  emit('update:modelValue', newItems)
}

function itemValidated(valid, randId) {
  props.modelValue.find(i => i.randId === randId).isValid = valid
  const dealershipId = props.dealershipId

  const invalidItems = props.modelValue.some(i => !i.isValid)
  const isItemsValid = !invalidItems

  emit('itemValidated', isItemsValid, dealershipId)
}

function itemRemoved(randId) {
  const dealershipId = props.dealershipId
  // useApiRequest()
  //   .send({
  //     endpoint: '/v1/finance/invoice-templates/' + props.invoiceTemplateId + '/items/' + id,
  //     method: 'DELETE'
  //   })
  //   .then(response => {
  //     if (response.success) {
  //       alertToast('Item Removed', null, 'success')
  //       // remove item from the list
  //       let newItems = props.modelValue.filter(item => item.id !== id)
  //       emit('update:modelValue', newItems)
  //     }
  //   })

  emit('itemRemoved', randId, dealershipId)
}

function newItemAdded(dealershipId, item) {
  emit('itemAdded', dealershipId, item)
  // emit('itemAdded', item)
  // console.log('newItemAdded', item)
  // Add the new item to the items array
  // let newItems = [...props.modelValue, item]
  // emit('update:modelValue', newItems)
}
</script>

<style>
/* Add any additional styling here */
</style>
